document.addEventListener("DOMContentLoaded", function (event) {

    /**
     * Slider produktowy
     */
    const postSlidersInit = () => {
        const postSliders = document.querySelectorAll('.c-post-slider__swiper');
        if (postSliders.length > 0) {
            postSliders.forEach(gallery => {
                const excerptsArr = [];
                new Swiper(gallery, {
                    slideToClickedSlide: true,
                    loop: true,
                    spaceBetween: 32,
                    pauseOnMouseEnter: true,
                    speed: 800,
                    // autoplay: {
                    //     delay: 2500,
                    //     disableOnInteraction: false
                    // },
                    navigation: {
                        nextEl: gallery.closest('.c-post-slider__box').querySelector('.c-post-slider__arrow--next'),
                        prevEl: gallery.closest('.c-post-slider__box').querySelector('.c-post-slider__arrow--prev')
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2
                        },
                        992: {
                            slidesPerView: 3
                        }
                    },
                    on: {
                        imagesReady: function () {
                            const excerpts = gallery.querySelectorAll('.c-single-post-loop__excerpt');
                            if (excerpts.length > 0) {
                                excerpts.forEach(excerpt => {
                                    excerptsArr.push(excerpt.clientHeight);
                                });
                                const max = Math.max(...excerptsArr);
                                const index = excerptsArr.indexOf(max);
                                excerpts.forEach(excerpt => {
                                    excerpt.style.height = excerptsArr[index] + 'px';
                                });
                            }
                        }
                    }
                });
            });
        }
    };

    postSlidersInit();

    if (window.acf) {
        window.acf.addAction('render_block_preview', postSlidersInit);
    }

});